/**
 * Resolve selected paged-filter ids to {label,value} rows.
 *
 * Do not use /lookup/map or /value-map/* — those return list indexes, not names (IP-15815).
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import api from '@utils/axios';
function toNumericIds(ids) {
    return ids.map((id) => Number(id)).filter((id) => !Number.isNaN(id));
}
function toOptions(payload) {
    var _a;
    if (!payload)
        return [];
    const rows = Array.isArray(payload) ? payload : (_a = payload.data) !== null && _a !== void 0 ? _a : [];
    return rows.map((item) => {
        var _a, _b;
        return ({
            value: item.value,
            label: item.label,
            subtitle: (_b = (_a = item.address) !== null && _a !== void 0 ? _a : item.subLabel) !== null && _b !== void 0 ? _b : undefined
        });
    });
}
export function loadLookupByIds(type, ids) {
    return __awaiter(this, void 0, void 0, function* () {
        const numericIds = toNumericIds(ids);
        if (numericIds.length === 0)
            return [];
        const response = yield api.get('/lookup', { params: { type, ids: numericIds } });
        return toOptions(response.data);
    });
}
export function loadAccountsByIds(ids) {
    return __awaiter(this, void 0, void 0, function* () {
        const numericIds = toNumericIds(ids);
        if (numericIds.length === 0)
            return [];
        const response = yield api.get('/lookup/accounts', { params: { ids: numericIds } });
        return toOptions(response.data);
    });
}
export function loadBuildingsByIds(ids) {
    return __awaiter(this, void 0, void 0, function* () {
        const numericIds = toNumericIds(ids);
        if (numericIds.length === 0)
            return [];
        const response = yield api.get('/lookup/buildings', { params: { ids: numericIds } });
        return toOptions(response.data);
    });
}
/** Resolve selected ids from a static option list (client-paged territories). */
export function loadSelectedFromOptions(options, extras = []) {
    return (ids) => __awaiter(this, void 0, void 0, function* () {
        const numericIds = toNumericIds(ids);
        if (numericIds.length === 0)
            return [];
        const wanted = new Set(numericIds);
        return [
            ...extras.filter((option) => wanted.has(option.value)),
            ...options
                .filter((option) => wanted.has(option.value))
                .map((option) => ({ value: option.value, label: option.label }))
        ];
    });
}
